export default __webpack_public_path__ + "static/HeldaneDisplayWeb-Regular-715d9cdea3dd7ccf56c52e166ae0a30f.eot";